<template>
  <div class="animated fadeIn">
    <div class="row">
      <div class="col-12 pt-3 pb-3 pl-4">
        <h3><i class="fas fa-briefcase"></i> Prognóstico</h3>
      </div>
    </div>
    <PrognosticoAdd v-if="showAdd" ref="PrognosticoAdd" v-on:Back="onBack" />
    <PrognosticoList v-else ref="PrognosticoList" v-on:New="onNew" v-on:Edit="onEdit"/>
  </div>
</template>
<script>
import Tools from '@/components/tools/Tools.js'
import PrognosticoAdd from './components/add/prognosticoadd.vue'
import PrognosticoList from './components/list/prognosticolist.vue'

export default {
  name: 'Prognostico',
  data () {
    return {
      showAdd: false
    }
  },
  components: {
    PrognosticoAdd,
    PrognosticoList
  },
  mounted () { },
  beforeDestroy () {
    this.$eventHub.off('Filter')
    Tools.MinimizedASidebar()
  },
  methods: {
    onLoad () {},
    onNew () {
      this.showAdd = true
    },
    onEdit (obj) {
      this.showAdd = true
      this.$nextTick(() => {
        this.$refs.PrognosticoAdd.onEdit(obj)
      })
    },
    onBack () {
      this.showAdd = false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/private/configurations/ajuizamento/prognostico/prognostico.vue